import React from 'react';
import PropTypes from 'prop-types';
import { ParagraphWrapper } from '../ParagraphWrapper';
import { ContentPackageTemplate1 } from './templates/ContentPackageTemplate1';
import { ContentPackageTemplate2a } from './templates/ContentPackageTemplate2a';
import { ContentPackageTemplate2b } from './templates/ContentPackageTemplate2b';
import { ContentPackageTemplate3a } from './templates/ContentPackageTemplate3a';
import { ContentPackageTemplate3b } from './templates/ContentPackageTemplate3b';
import { ContentPackageTemplate3c } from './templates/ContentPackageTemplate3c';
import { ContentPackageTemplate4a } from './templates/ContentPackageTemplate4a';
import { ContentPackageTemplate4b } from './templates/ContentPackageTemplate4b';
import { ContentPackageTemplate5a } from './templates/ContentPackageTemplate5a';
import { ContentPackageTemplate5b } from './templates/ContentPackageTemplate5b';
import { ContentPackageTemplate6a } from './templates/ContentPackageTemplate6a';
import { ContentPackageTemplate6b } from './templates/ContentPackageTemplate6b';

const templateComponentConfig = {
  template_1_content: ContentPackageTemplate1,
  template_2_contents_a: ContentPackageTemplate2a,
  template_2_contents_b: ContentPackageTemplate2b,
  template_3_contents_a: ContentPackageTemplate3a,
  template_3_contents_b: ContentPackageTemplate3b,
  template_3_contents_c: ContentPackageTemplate3c,
  template_4_contents_a: ContentPackageTemplate4a,
  template_4_contents_b: ContentPackageTemplate4b,
  template_5_contents_a: ContentPackageTemplate5a,
  template_5_contents_b: ContentPackageTemplate5b,
  template_6_contents_a: ContentPackageTemplate6a,
  template_6_contents_b: ContentPackageTemplate6b
};

const ContentPackageInner = ({ data, content, isAboveTheFold = false }) => {
  const tweakedData = {
    ...data,
    backgroundColor:
      data.backgroundColor === 'gray' ? '#f7f7f7' : data.backgroundColor
  };
  const TemplateComponent = templateComponentConfig[tweakedData.template];
  return TemplateComponent ? (
    <TemplateComponent
      data={tweakedData}
      content={content}
      isAboveTheFold={isAboveTheFold}
    />
  ) : (
    <div />
  );
};

ContentPackageInner.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  content: PropTypes.objectOf(PropTypes.any).isRequired,
  isAboveTheFold: PropTypes.bool
};

export const ContentPackage = ParagraphWrapper(ContentPackageInner);
